<template>
  <div id="app">
    <div id="nav">
      <div style="width:7%"></div>
      <img class="logo" src="//txwl.huohuoche.com/txws/new_images_one/logo.png" />
      <a :class="{'router-link-active':isCheck=='home'}" @click="jump('home')">
        <span>首页</span>
      </a>
      <a :class="{'router-link-active':isCheck=='txw'}" @click="jump('txw')">
        <span>天下包网</span>
      </a>
      <!-- <a :class="{'router-link-active':isCheck=='txlive'}" @click="jump('txlive')">
        <span>WG视讯</span>
      </a> -->
      <a :class="{'router-link-active':isCheck=='dtqp'}" @click="jump('dtqp')">
        <span>大唐棋牌</span>
      </a>
      <a :class="{'router-link-active':isCheck=='dtfish'}" @click="jump('dtfish')">
        <span>大唐捕鱼</span>
      </a>
      <a :class="{'router-link-active':isCheck=='exhibition'}" @click="jump('exhibition')">
        <span>展会资讯</span>
      </a>
      <a @click="globalVariable.tryGame('successStories')" >
        <span>成功案例</span>
      </a>
      <!-- <a :class="{'router-link-active':isCheck=='tryGame'}" @click="jump('tryGame')">
        <span>立即体验</span>
      </a>-->
      <!-- 顶部联系方式滚动 -->
      <tx-contact class="scrollContainer"></tx-contact>
      <div style="width:7%"></div>
    </div>

    <router-view />
    <!-- 联系我们 -->
    <!-- 我要开版 -->
    <div id="OpeningEdition" v-show="openEditionStatus||concatUsStatus" @click.self="close">
      <div class="box" v-show="openEditionStatus">
        <div class="top_line"></div>
        <!-- <span class="close" @click="closeEdition"></span> -->
        <h2>我要开版</h2>
        <el-input v-model="formData.customerName" placeholder="姓名"></el-input>
        <el-input v-model="formData.contactNumber" placeholder="联系方式"></el-input>
        <el-input
          v-model="formData.contactMatters"
          type="textarea"
          :rows="4"
          placeholder="请简单描述您的需求"
        ></el-input>
        <p>请至少填写一种联系方式，并描述 您的需求，我们将尽快与您联系。</p>
        <el-button type="danger" @click="submit" style="height:50px;">提交</el-button>
      </div>
      <div class="concat" v-show="concatUsStatus">
        <div class="top_line" :style="{left:tabValue=='0'?'0%':'50%'}"></div>
       <!-- <span class="close" @click="closeConcatUs"></span> -->
       <el-tabs type="border-card" v-model="tabValue">
          <el-tab-pane label="立即咨询" class="bwzx">
            <a
              :href="item.url || 'javascript:;'"
              :target="item.url?'_blank':'_self'"
              :class="{card_item:true,card_item_hover:item.key==bwIndex}"
              v-for="item in bwList"
              :key="item.key"
              @mouseenter="bwIndex=item.key"
            >
              <img :src="'//txwl.huohuoche.com/txws/new_images_one/'+item.icon" />
              <p>{{item.msg}}</p>
            </a>
          </el-tab-pane>
        <!--   <el-tab-pane label="API咨询" class="apizx">
            <a
              :href="item.url || 'javascript:;'"
              :target="item.url?'_blank':'_self'"
              :class="{card_item:true,card_item_hover:item.key==apiIndex}"
              v-for="item in apiList"
              :key="item.key"
              @mouseenter="apiIndex=item.key"
            >
              <img :src="'//txwl.huohuoche.com/txws/new_images_one/'+item.icon" />
              <p>{{item.msg}}</p>
            </a>
          </el-tab-pane> -->
        </el-tabs>
     <!--    <div class="top_line" ></div>
        <el-tabs type="border-card">
         <h2 class="title-h2">立即咨询</h2>
          <a :href="item.url || 'javascript:;'" v-for="item in bwList" :key="item.key" :class="{'item-box':true, 'squareBox':item.key==2 || item.key ==3}" :target="item.url?'_blank':'_self'">
            <img class="item-img" :src="'//txwl.huohuoche.com/txws/new_images_one/'+item.icon">
            <p>{{item.msg}}</p>
          </a>

        </el-tabs> -->
      </div>
    </div>
    <!-- 底部文案 -->
    <div class="foot_text">Copyright © 2016 - 2020 天下网络 All Right Reserved</div>
  </div>
</template>

<script>
import txContact from "./common/tx-contact";
import qs from "qs";
export default {
  components: {
    txContact
  },
  name: "App",
  data() {
    return {
      isCheck: "home",
      tabValue: "0",
      formData: {
        customerName: "",
        contactNumber: "",
        contactMatters: ""
      },
      bwIndex: 1,
      apiIndex: 1,
      bwList: [
         {
          key: 3,
          icon: "line.png",
          // msg: "Line",
           msg: "@txkj18899",
          url: ""
        },




       /* {
          key: 1,
          icon: "button_phone.png",
          msg: "+63 998 167 6789",
          // url: "https://pt.im/txwlgfzh"
           url: ""
        },*/
        // {
        //   key: 1,
        //   icon: "telegram.png",
        //   msg: "@TX_GROUP",
        //   // url: "https://pt.im/txwlgfzh"
        //   url: "https://t.me/TX_GROUP"
        // },
        {
          key: 2,
          icon: "telegram.png",
          msg: "@TX_GROUP998",
          // url: "https://t.me/txwlgfzh"
          url: "https://t.me/TX_GROUP998"
        },
     /*
        {
          key: 4,
          icon: "qq.png",
          msg: "QQ1",
          url: "http://wpa.qq.com/msgrd?v=3&uin=632299999&site=qq&menu=yes"
        },
        {
          key: 5,
          icon: "qq.png",
          msg: "QQ2",
          url: "http://wpa.qq.com/msgrd?v=3&uin=202199999&site=qq&menu=yes"
        }, */
        {
          key: 6,
          icon: "email.png",
          msg: "txkj8899@gmail.com",
          url: "mailto:txkj8899@gmail.com"
        }
      ],
      apiList: [
        {
          key: 1,
          icon: "potato.png",
          msg: "Potato",
          url: "https://pt.im/txwlbw"
        },
        {
          key: 2,
          icon: "telegram.png",
          msg: "Telegram",
          url: "https://t.me/TX_GROUP998"
        },
        {
          key: 3,
          icon: "line.png",
          msg: "Line",
          url: ""
        },
        { key: 4, icon: "button_phone.png", msg: "Telephone", url: "" },
        {
          key: 5,
          icon: "email.png",
          msg: "txkj8899@gmail.com",
          url: "mailto:txkj8899@gmail.com"
        }
      ]
    };
  },
  mounted() {},
  methods: {
    //路由跳转
    jump: function(type) {
      switch (type) {
        case "home": //首页
          this.isCheck = "home";
          this.$router.push("/home");
          break;
        case "txw": //天下包网
          this.isCheck = "txw";
          this.$router.push("/txw");
          break;
       /*  case "txlive": //天下汇视讯
          // this.isCheck = "txlive";
          window.open(this.globalVariable.txh_gw, "_blank");
          break; */
        case "dtqp": //大唐棋牌
          this.isCheck = "dtqp";
          this.$router.push("/dtqp");
          break;
        case "dtfish": //大唐捕鱼
          this.isCheck = "dtfish";
          this.$router.push("/dtfish");
          break;
        case "exhibition": //展会资讯
          this.isCheck = "exhibition";
          this.$router.push("/exhibition");
          break;
        case "successStories": //成功案例
          break;
        case "tryGame": //立即体验
          this.isCheck = "tryGame";
          this.$router.push("/tryGame");
          break;
      }
    },
    //关闭框
    close() {
      this.$store.commit("CHANGEOPENEDITIONSTATUS", false);
      this.$store.commit("CHANGECONCATUSSTATUS", false);
    },
    closeEdition() {
      this.$store.commit("CHANGEOPENEDITIONSTATUS", false);
    },
    closeConcatUs() {
      this.$store.commit("CHANGECONCATUSSTATUS", false);
    },
    //开版提交
    async submit() {
      try {
        if (
          !/^[\u4e00-\u9fa5][\u4e00-\u9fa5.]{0,8}[\u4e00-\u9fa5]$/.test(
            this.formData.customerName
          )
        ) {
          this.$message.error("请输入真实姓名");
          return false;
        } else if (
          this.formData.contactNumber.replace(/(^\s*)|(\s*$)/g, "") === "" ||
          this.formData.contactNumber.match(/[\u4e00-\u9fa5]/)
        ) {
          this.$message.error("请输入正确的联系方式");
          return false;
        } else if (
          this.formData.contactMatters.replace(/(^\s*)|(\s*$)/g, "") === ""
        ) {
          this.$message.error("请简单描述您的需求");
          return false;
        }
        await this.request.post("/sendEmail", this.formData);
        this.$message({
          message: "提交成功",
          type: "success"
        });
        this.closeEdition();
      } catch (e) {
        this.$message.error(e.message);
      }
    }
  },
  computed: {
    //开版状态
    openEditionStatus: function() {
      return this.$store.state.openEditionStatus;
    },
    //联系我们
    concatUsStatus: function() {
      return this.$store.state.concatUsStatus;
    }
  },
  watch: {
    $route() {
      let routeName = this.$route.name;
      // console.log(routeName)
      if (routeName == "home") {
        this.isCheck = "home";
      } else if (routeName == "txw") {
        this.isCheck = "txw";
      } else if (routeName == "txlive") {
        this.isCheck = "txlive";
      } else if (routeName == "dtqp") {
        this.isCheck = "dtqp";
      } else if (routeName == "dtfish") {
        this.isCheck = "dtfish";
      } else if (
        routeName == "twentyPage" ||
        routeName == "starBlessing" ||
        routeName == "pageVideo" ||
        routeName == "pagePicture" ||
        routeName == "pageIntroduce" ||
        routeName == "geVideo" ||
        routeName == "gePicture" ||
        routeName == "geIntroduce"
      ) {
        this.isCheck = "exhibition";
      } else if (routeName == "pcTemplate" || routeName == "appTemplate") {
        this.isCheck = "successStories";
      } else if (
        routeName == "ysz" ||
        routeName == "chess" ||
        routeName == "fish" ||
        routeName == "live"
      ) {
        this.isCheck = "tryGame";
      }
    }
  }
};
</script>

<style lang='scss'>
@import "@/assets/scss/global.scss";
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  min-width: 1400px;
  min-height: 800px;
}
#app {
  position: relative;
  width: 100%;
  height: 100%;
  // min-width:1920px;
  // min-height: 800px;
  // background:#000000;
  background: url("//txwl.huohuoche.com/txws/new_images_one/bg.jpg")
    no-repeat center;
  background-size: cover;
  .foot_text {
    width: 100%;
    height: 30px;
    font-size: 14px;
    background: rgba(00, 00, 00, 0.7);
    font-family: PingFang SC;
    font-weight: 300;
    color: #78787d;
    line-height: 30px;
    text-align: center;
    position: absolute;
    bottom: 0%;
    z-index: 10000;
  }
  #OpeningEdition {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    // background: rgba(00, 00, 00, 0.7);
    z-index: 9999;
    .box {
      position: absolute;
      right: 9%;
      bottom: 6%;
      width: 300px;
      height: 410px;
      z-index: 10000;
      background: linear-gradient(
        0deg,
        rgba(38, 36, 72, 1) 0%,
        rgba(28, 30, 71, 1) 100%
      );
      padding: 1%;
      color: $fontWhite;
      display: flex;
      flex-direction: column;
      align-items: left;
      opacity: 1;
      .top_line {
        width: 100%;
        height: 4px;
        background: linear-gradient(
          90deg,
          rgba(82, 2, 52, 1) 0%,
          rgba(56, 5, 88, 1) 100%
        );
        position: absolute;
        top: -2px;
        left: 0;
      }
      .close {
        width: 25px;
        height: 25px;
        background: url("//txwl.huohuoche.com/txws/new_images_one/plus.png")
          no-repeat center;
        background-size: cover;
        position: absolute;
        right: 2%;
        top: 2%;
        transform: rotate(40deg);
      }
      h2 {
        font-size: $fontSize_24;
        font-family: PingFang SC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 15px;
      }
      .el-input__inner {
        height: 50px;
        background: rgba(17, 19, 50, 1);
        border: 1px solid rgba(128, 128, 153, 1);
        border-radius: 28px !important;
        margin-top: 7%;
        color: $fontWhite;
      }
      .el-textarea__inner {
        font-size: $fontSize_16;
        // height: 35px;
        background: rgba(17, 19, 50, 1);
        border: 1px solid rgba(128, 128, 153, 1);
        margin-top: 7%;
        color: $fontWhite;
      }
      p {
        font-size: $fontSize_16;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(114, 118, 146, 1);
        line-height: 24px;
        margin-top: 4%;
      }
      .el-button--danger {
        width: 100%;
        background: linear-gradient(
          90deg,
          rgba(230, 0, 106, 1) 0%,
          rgba(248, 55, 37, 1) 100%
        );
        border-radius: 28px;
        margin-top: 5%;
        font-size: $fontSize_20;
      }
    }
    .concat {
      position: absolute;
      right: 9%;
      bottom: 6%;
      width: 300px;
      height: 330px;
      z-index: 9999;
      background: linear-gradient(
        0deg,
        rgba(38, 36, 72, 1) 0%,
        rgba(28, 30, 71, 1) 100%

      );
      color: $fontWhite;
      opacity: 1;
      .top_line {
        width: 100%;
        height: 4px;
        background: linear-gradient(
          90deg,
          rgba(82, 2, 52, 1) 0%,
          rgba(56, 5, 88, 1) 100%
        );
        position: absolute;
        top: 0px;
        left: 0%;
        z-index: 999;
      }

 /*        .title-h2{
          font-size:24px;
          padding-left:20px;
          margin:10px 0 30px 0
        }
       .squareBox {
          width: 45% !important;
          float:left !important;
          margin:6px !important;
          img {
            display: block !important;
            width:100%;
          }
          p {
            display:inline-block;
          }


        }
        .item-box{
          display:flex;
          width:260px;height:50px;
          flex-direction: row;
          justify-content: left;
          align-items: center;
          margin: auto;
          border-radius: 5px;
          background: #42436c;
          margin-bottom:20px;
          text-decoration:none;

          p {

            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #181836;
            line-height: 15px;

          }
        }
        .item-img {
          width:20;height:20px;margin:0 20px
        } */

      .close {
        width: 25px;
        height: 25px;
        background: url("//txwl.huohuoche.com/txws/new_images_one/plus.png")
          no-repeat center;
        background-size: cover;
        position: absolute;
        right: -11%;
        top: -7%;
        transform: rotate(40deg);
      }
      .el-tabs--border-card {
        height: 100%;
      /*   background: linear-gradient(
          0deg,
          rgba(38, 36, 72, 1) 0%,
          rgba(28, 30, 71, 1) 100%
        ); */
        background:#262448;
        border: none;
      }
      .el-tabs__header {
        border: none;
      }
      .el-tabs__item {
        width: 150px;
        padding: 0;
        margin: 0;
        height: 45px;
        line-height: 45px;
        font-size: $fontSize_18;
        border: none;
        text-align: center;
        background:#262448;
        transition: auto;
      }
      .el-tabs__nav-wrap {
        padding: 13px 0 0 0;
        border: none;
      /*   background: -webkit-gradient(linear, left bottom, left top, from(#262448), to(#1c1e47));
        background: linear-gradient(0deg, #262448 0%, #1c1e47 100%); */
        background:#262448;

      }
      .el-tabs__item.is-active {
       /*  background: linear-gradient(
          0deg,
          rgba(38, 36, 72, 1) 0%,
          rgba(28, 30, 71, 1) 100%
        ); */
        border: none;
        color: $fontWhite;
      }
      .bwzx,
      .apizx {
        display: flex;
        flex-wrap: wrap;
        .card_item:nth-child(2) {
          p {
            font-size:15px
          }
        }
        .card_item {
          width: 120px;
          height: 100px;
          margin: 7px;
          background:#42436c;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-decoration: none;
          img {
            width: 40px;
            height: 40px;
          }
          p {
            margin-top: 10px;
            font-size: $fontSize_18;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(24, 24, 54, 1);
            line-height: 15px;
          }
        }
        .card_item_hover {
          background: #cb0954;
          cursor: pointer;
        }
     /*    .card_item:nth-child(3) {

        } */

        .card_item:last-child,.card_item:nth-child(3) {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          width: 295px;
          height: 50px;
          border-radius: 5px;
          padding-left:20px;
          img {
            width: 20px;
            height: 20px;
          }
          p {
            margin: 0 0 0 8px;
          }

        }
        .qq_style1,
        .qq_style2 {
          height: 45px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          img {
            width: 25px;
            height: 25px;
          }
          p {
            margin: 0 0 0 8px;
          }
        }
        .qq_style2 {
          position: absolute;
          right: 16px;
          top: 183px;
        }
      }
    }
  }
}
#nav {
  position: relative;
  font-size: 0.24rem;
  width: 100%;
  // max-width:1920px;
  margin: auto;
  height: 78px;
  background: rgba(00, 00, 00, 0.6);
  display: flex;
  justify-content: space-around;
  align-items: center;
  // margin:0 20px;
  z-index: 999;
  .logo {
    height: 60px;
    margin-top: 2px;
  }
  a {
    font-weight: bold;
    color: $fontNav;
    text-decoration: none;
    font-size: $fontSize_18;
    font-weight: 300;
    cursor: pointer;
    span {
      padding: 23px 0;
    }
    &.router-link-active {
      font-size: $fontSize_18;
      color: $red;
      span {
        font-size: $fontSize_20;
        border-bottom: 2px solid $red;
        color: $red;
        font-weight: bold;
      }
    }
  }
  .scrollContainer {
    width: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue